document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-announcement]').forEach(function (root) {
    var items = Array.from(root.querySelectorAll('[data-announcement-item]'));
    if (items.length < 2) return;
    var index = 0;
    var delay = parseInt(root.dataset.speed || '3800', 10);
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    window.setInterval(function () {
      items[index].classList.remove('is-active');
      index = (index + 1) % items.length;
      items[index].classList.add('is-active');
    }, Math.max(2200, delay));
  });
  document.querySelectorAll('[data-menu-toggle]').forEach(function (button) {
    button.addEventListener('click', function () {
      var nav = document.querySelector(button.getAttribute('data-menu-toggle'));
      if (!nav) return;
      var open = nav.classList.toggle('is-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
  document.querySelectorAll('[data-selector-group]').forEach(function (group) {
    var cards = Array.from(group.querySelectorAll('[data-selector-card]'));
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        cards.forEach(function (item) { item.classList.remove('is-selected'); });
        card.classList.add('is-selected');
      });
    });
  });
});
